// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Warp Gates Configuration - Universe L-Space
 * 
 * Gateway connections to other universes.
 */

export const warpGates = [
  {
    id: 'gate_lspace_to_discworld',
    name: 'DISCWORLD PORTAL',
    distance: 35,
    threat: 'NARRATIVE',
    resources: 'KNOWLEDGE',
    services: ['refuel', 'trade'],
    description: 'Portal to Discworld through the Unseen University library. Ook!',
    type: 'warpgate',
    discovered: true,
    destinationUniverse: 'discworld',
    destinationGate: 'gate_discworld_to_lspace',
    toSystem: 500,
    fuelRequired: 5,
    primaryColor: '#8B4513',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true,
  }
];

export const warpGatePositions = {
  'gate_lspace_to_discworld': { x: 52, y: 48, z: -3 }
};
